import { styled } from '@mui/material'

// origin = the wordmark's dot centre
const CLIP_ORIGIN = '95.05% 81.34%'

export const Overlay = styled('span')`
  position: absolute;
  inset: 0;
  display: block;
  clip-path: circle(0% at ${CLIP_ORIGIN});
  transition: clip-path 450ms cubic-bezier(0.25, 0.1, 0.25, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const Wrapper = styled('span')`
  position: relative;
  display: inline-flex;
  line-height: 0;

  &:hover ${Overlay} {
    clip-path: circle(135% at ${CLIP_ORIGIN});
  }
`
